import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import '../styles/tokens.css';
import { PageShell } from '../components/layout';
import { MamahoodMarketingHeader, SiteHeader, SiteFooter } from '../components/navigation';

const Shell = styled(PageShell)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export function TwentyTwentysixSiteLayout() {
  return (
    <Shell className="twentytwentysix-site">
      <SiteHeader />
        <MamahoodMarketingHeader />
      <Outlet />
      <SiteFooter />
    </Shell>
  );
}

export default TwentyTwentysixSiteLayout;
